import { render, staticRenderFns } from "./ScreenLaudoPelvicaTransabdominal.vue?vue&type=template&id=732f5669&lang=true&"
import script from "./ScreenLaudoPelvicaTransabdominal.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoPelvicaTransabdominal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports